import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import styles from "./ImageUploader.module.scss";
import DragNDropFile from "../../../../../components/Admin/DragNDropFile/DragNDropFile";
import { MessageContext } from "../../../../../context/message/MessageContext";
import ThemedButton from "../../../../../components/Admin/ThemedButton/ThemedButton";
import useUpload from "../../../../../data-access/useUpload";

const ImageUploader = ({ input, setInput, name }) => {
  const [image, setImage] = useState();
  const { addError, addSuccess } = useContext(MessageContext);
  const { upload, uploadLoading } = useUpload();

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append("file", image);

    upload(formData, {
      onSuccess: (data) => {
        setInput((prev) => ({
          ...prev,
          [name]: [...prev[name], data?.url],
        }));
        setImage();
        return addSuccess("Image Uploaded Successfully");
      },
      onError: (err) => {
        addError({
          text: `Error in uploading image: ${err.response.data.msg}`,
        });
      },
    });
  };

  return (
    <div className={styles.imageContainer}>
      <div className={styles.uploadedImages}>
        {input?.[name]?.map((img, index) => (
          <div className={styles.imageBox}>
            <i
              class="fa-solid fa-circle-xmark fa-lg"
              onClick={() => {
                setInput((prev) => ({
                  ...prev,
                  [name]: prev?.[name]?.filter((_, i) => i !== index),
                }));
              }}
            ></i>
            <img src={img} alt="img" />
          </div>
        ))}
      </div>
      <div className={styles.imageUploader}>
        <div className={styles.imageBox}>
          <div className={styles.preview}>
            <img
              src={
                image
                  ? URL.createObjectURL(image)
                  : "/images/imagePlaceholder.jpg"
              }
              alt="img"
            />
          </div>
          <div className={styles.input}>
            <DragNDropFile
              droppedFile={image}
              setDroppedFile={setImage}
              className={styles.dnd}
              extnsAllowed={["jpeg", "png", "jpg"]}
            />
          </div>
        </div>
        <div className={styles.uploadBtn}>
          <ThemedButton
            theme={"PRIMARY"}
            onClick={handleUpload}
            className={styles.btn}
            loading={uploadLoading}
          >
            Upload
          </ThemedButton>
        </div>
      </div>
    </div>
  );
};

export default ImageUploader;
